/**
 * Labstep
 *
 * @module constants/cursor
 * @desc API default cursor for pagination
 */

export const DEFAULT_CURSOR = '-1';
